// extracted by mini-css-extract-plugin
export var addToCartButton = "_nv-b";
export var arrowButtonContainer = "_nv-9";
export var arrowButtonIcon = "_nv-a";
export var carouselArrowButton = "_nv-6";
export var carouselElementContainer = "_nv-1";
export var galleryThumbnail = "_nv-d";
export var galleryThumbnailImage = "_nv-e";
export var left = "_nv-7";
export var productDisplayCarouselContainer = "_nv-0";
export var productTileContainer = "_nv-2";
export var productTileImage = "_nv-4";
export var productTileImageContainer = "_nv-3";
export var productTileTitle = "_nv-5";
export var right = "_nv-8";
export var sliderOverflow = "_nv-c";